export function stopEventPropagation(event: Event) {
  if (event.stopPropagation) {
    // modern browsers
    event.stopPropagation()
  }
}
